import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    const defaultState = {
      list_all: {
        list: [],
        error: null,
        loading: true
      },
      detail: {
        data: null,
        error: null,
        loading: true
      },
    };

    super('transactions', defaultState);
    this.defaultState = defaultState;
  }

  async setupEvents() {
    this.on(constants.EVENTS.TRANSACTIONS.DETAIL.SHOW, () => {
      this.state.detail.loading = true;
      this.state.detail.error = null;
      this.state.detail.data = null;
    });
    this.on(constants.EVENTS.TRANSACTIONS.DETAIL.REFRESHED, (data) => {
      this.state.detail.data = data;
      this.state.detail.loading = false;
      this.state.detail.error = null;
    });
    this.on(constants.EVENTS.TRANSACTIONS.DETAIL.REFRESH_ERROR, (error) => {
      this.state.detail.loading = false;
      this.state.detail.error =
        error?.message || error || "Une Erreur inconnue s'est produite";
    });

    
    this.on(constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESHING, () => {
      this.state.list_all.loading = true;
      this.state.list_all.error = null;
    });

    this.on(constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESHED, (data) => {
      this.state.list_all.list = Array.isArray(data) ? data : [];
      this.state.list_all.loading = false;
      this.state.list_all.error = Array.isArray(data)
        ? null
        : 'Mauvais format de donnée';
    });

    this.on(constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH_ERROR, (error) => {
      this.state.list_all.loading = false;
      this.state.list_all.error = error?.message || error;
      this.state.list_all.list = [];
    });
  }
}

export default Store;
// new Store();
